var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircleTone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 3.5C14.9703 3.5 4 14.4703 4 28C4 41.5297 14.9703 52.5 28.5 52.5C42.0297 52.5 53 41.5297 53 28C53 14.4703 42.0297 3.5 28.5 3.5ZM28.5 48.3438C17.2672 48.3438 8.15625 39.2328 8.15625 28C8.15625 16.7672 17.2672 7.65625 28.5 7.65625C39.7328 7.65625 48.8438 16.7672 48.8438 28C48.8438 39.2328 39.7328 48.3438 28.5 48.3438Z",
    fill: "#006854"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M28.5 7.65625C17.2672 7.65625 8.15625 16.7672 8.15625 28C8.15625 39.2328 17.2672 48.3438 28.5 48.3438C39.7328 48.3438 48.8438 39.2328 48.8438 28C48.8438 16.7672 39.7328 7.65625 28.5 7.65625ZM39.0766 19.9992L27.5594 35.968C27.3984 36.1926 27.1862 36.3757 26.9403 36.502C26.6945 36.6283 26.4221 36.6942 26.1457 36.6942C25.8693 36.6942 25.5969 36.6283 25.3511 36.502C25.1052 36.3757 24.893 36.1926 24.732 35.968L17.918 26.518C17.7102 26.2281 17.918 25.8234 18.2734 25.8234H20.8383C21.4016 25.8234 21.9266 26.0969 22.2547 26.5508L26.1484 31.9539L34.7453 20.032C35.0734 19.5727 35.6039 19.3047 36.1617 19.3047H38.7266C39.082 19.3047 39.2898 19.7094 39.0766 19.9992Z",
    fill: "#006854"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7244 19.3047H36.1595C35.6017 19.3047 35.0713 19.5727 34.7431 20.032L26.1462 31.9539L22.2525 26.5508C21.9243 26.0969 21.3993 25.8234 20.8361 25.8234H18.2712C17.9157 25.8234 17.7079 26.2281 17.9157 26.518L24.7298 35.968C24.8908 36.1926 25.103 36.3757 25.3488 36.502C25.5947 36.6283 25.8671 36.6942 26.1435 36.6942C26.4199 36.6942 26.6923 36.6283 26.9381 36.502C27.184 36.3757 27.3962 36.1926 27.5572 35.968L39.0744 19.9992C39.2877 19.7094 39.0799 19.3047 38.7244 19.3047Z",
    fill: "#006854"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleTone);
export default __webpack_public_path__ + "static/media/check-circle-tone.67866014086be6f6d50b946a6829361a.svg";
export { ForwardRef as ReactComponent };